export default __webpack_public_path__ + "a9f2bd41ed55ce1009961ccb56b48406.png";